/* Native article enhancement; saved article content remains in the initial HTML. */
if (!customElements.get('pp-editorial')) {
  const productRequests = new Map();
  customElements.define('pp-editorial', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) { this.pendingProducts?.forEach(container => this.productObserver?.observe(container)); return; }
      this.initialized = true;
      const body = this.querySelector('[data-article-body]');
      if (!body) return;
      // Legacy images sometimes keep their URL only in data attributes.
      body.querySelectorAll('img').forEach(img => {
        if (img.dataset.src && !img.getAttribute('src')) img.src = img.dataset.src;
        if (img.dataset.srcset && !img.getAttribute('srcset')) img.srcset = img.dataset.srcset;
        if (!img.hasAttribute('loading')) img.loading = 'lazy';
        img.decoding = 'async';
        if (!img.sizes || img.sizes === 'auto') img.sizes = '(max-width: 767px) calc(100vw - 40px), 740px';
      });
      const firstImage = body.querySelector('img[src]:not([src=""])');
      if (firstImage) firstImage.loading = 'eager';
      body.querySelectorAll('p').forEach(p => {
        if (!p.textContent.trim() && !p.querySelector('img,iframe,video,button,input')) p.hidden = true;
      });
      body.querySelectorAll('.faq--container').forEach((old, index) => {
        const q = old.querySelector('.bggle--question-title');
        const answer = old.querySelector('.reponse');
        if (!q || !answer) return;
        const details = document.createElement('details');
        details.className = 'pp-article-faq';
        details.name = `pp-faq-${this.dataset.section}`;
        if (old.id) details.id = old.id;
        const summary = document.createElement('summary');
        summary.textContent = q.textContent.trim();
        const content = document.createElement('div');
        content.append(answer); details.append(summary, content); old.replaceWith(details);
      });
      const containers = [...body.querySelectorAll('[bggle-product-handle], .bggle_product-container')];
      this.pendingProducts = new Set(containers.filter(node => !containers.some(other => other !== node && other.contains(node))));
      if ('IntersectionObserver' in window) {
        this.productObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.productObserver.unobserve(entry.target);
            this.pendingProducts.delete(entry.target);
            this.productCard(entry.target);
          });
        }, {rootMargin: '400px'});
        this.pendingProducts.forEach(container => this.productObserver.observe(container));
      } else this.pendingProducts.forEach(container => this.productCard(container));
    }
    disconnectedCallback() {
      this.productObserver?.disconnect();
    }
    async productCard(container) {
      const oldLink = container.querySelector('a[href]');
      let linkedHandle = '';
      try { linkedHandle = new URL(oldLink?.getAttribute('href') || '', location.origin).pathname.match(/\/products\/([^/]+)/)?.[1] || ''; } catch (_) {}
      const handle = container.getAttribute('bggle-product-handle') || linkedHandle;
      if (!handle || !/^[a-zA-Z0-9_-]+$/.test(handle)) return;
      const root = window.Shopify?.routes?.root || '/';
      const link = document.createElement('a');
      link.className = 'pp-article-product';
      link.href = `${root}products/${encodeURIComponent(handle)}`;
      const label = document.createElement('span');
      label.textContent = 'Se produktet';
      link.append(label);
      // These containers contain only Bloggle's generated product widget.
      // The surrounding editorial text and its links are left intact.
      container.replaceChildren(link);
      try {
        const key = `${link.pathname}.js`;
        if (!productRequests.has(key)) {
          productRequests.set(key, fetch(key, {signal: AbortSignal.timeout(8000)}).then(response => {
            if (!response.ok) throw new Error('Product unavailable');
            return response.json();
          }).catch(error => { productRequests.delete(key); throw error; }));
        }
        const product = await productRequests.get(key);
        if (!this.isConnected) return;
        const title = document.createElement('strong');
        title.textContent = window.PPProductNames?.clean(product.title) || product.title;
        link.prepend(title);
        if (product.featured_image) {
          const url = new URL(product.featured_image, location.origin);
          if (url.protocol !== 'https:' && url.protocol !== 'http:') return;
          url.searchParams.set('width', '500');
          const img = document.createElement('img');
          img.width = 500; img.height = 500; img.decoding = 'async';
          img.src = url.href; img.alt = title.textContent; img.loading = 'lazy';
          link.prepend(img);
        }
      } catch (_) {
        // The link remains usable when the product request fails.
      }
    }
  });
}
